import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { getCountries, getLogisticsCategories } from './apis'
import { CodeItem } from './types'

export const commonCodeQueryKeys = {
  all: ['COMMON_CODE'] as const,
  countries: () => [...commonCodeQueryKeys.all, 'countries'] as const,
  logisticsCategories: () => [...commonCodeQueryKeys.all, 'logisticsCategories'] as const,
}

const STALE_TIME = 1000 * 60 * 10 // 10분 — 코드성 데이터

// enabled=false 면 조회 자체를 막는다(LP9182: 국가 차원 flag OFF 시 정산관리에서 호출 안 함 → 불필요한 조회/실패 알럿 차단). 기본 true 로 기존 호출(단가관리 등) 무영향.
export const useGetCountries = (enabled = true): UseQueryResult<CodeItem[], Error> =>
  useQuery({
    queryKey: commonCodeQueryKeys.countries(),
    queryFn: getCountries,
    select: ({ data }) => data?.items ?? [],
    staleTime: STALE_TIME,
    enabled,
  })

export const useGetLogisticsCategories = (): UseQueryResult<CodeItem[], Error> =>
  useQuery({
    queryKey: commonCodeQueryKeys.logisticsCategories(),
    queryFn: getLogisticsCategories,
    select: ({ data }) => data?.items ?? [],
    staleTime: STALE_TIME,
  })
